/* FRILLORA-MISSING-COLOR-NOTICE-v1 */
(() => {
  const resolvePhoto = function resolveMissingColorPhoto(selected, variants, roles) {
  if (!selected) return { kind: 'unknown', image: null, sourceVariantId: null };
  const imageOf = (variant) => {
    const raw = variant?.image || variant?.featured_image;
    if (typeof raw === 'string' && raw) return { src: raw, alt: '', id: '' };
    if (raw && typeof (raw.src || raw.url) === 'string' && (raw.src || raw.url)) {
      return { src: raw.src || raw.url, alt: raw.alt || '', id: String(raw.id || '') };
    }
    return null;
  };
  const own = imageOf(selected);
  if (own) return { kind: 'direct', image: own, sourceVariantId: String(selected.id) };
  const colorIndex = roles.indexOf('color');
  if (colorIndex >= 0 && Array.isArray(selected.options)) {
    const sibling = variants.find((candidate) => {
      if (!imageOf(candidate) || !Array.isArray(candidate.options)
          || candidate.options.length !== selected.options.length) return false;
      return selected.options.every((value, index) => {
        if (index !== colorIndex && (roles[index] === 'size' || roles[index] === 'pair')) return true;
        return candidate.options[index] === value;
      });
    });
    if (sibling) return { kind: 'shared', image: imageOf(sibling), sourceVariantId: String(sibling.id) };
  }
  return { kind: 'missing', image: null, sourceVariantId: null };
};
  const stockState = function classifyMissingColorStock(variant) {
  if (!variant) return 'unknown';
  if (variant.available !== true) return 'sold_out';
  // available includes continue-selling and untracked inventory. Neither proves stock.
  if (variant.inventoryManaged === true && Number.isFinite(variant.inventoryQuantity)
      && variant.inventoryQuantity > 0) return 'in_stock';
  return 'orderable';
};
  const initialize = () => {
    const dataNode = document.querySelector('[data-fr-missing-color-data]');
    const scope = document.querySelector('.fr-pdp-card');
    if (!dataNode || !scope || scope.dataset.frMissingColorReady === '1') return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    if (!Array.isArray(data.variants) || !Array.isArray(data.roles)) return;
    const input = scope.querySelector('[data-product-variant-id]');
    const pdp = scope.closest('.fr-pdp') || document;
    const gallery = pdp.querySelector('[data-pdp-gallery]');
    const mainImage = gallery?.querySelector('[data-pdp-main-image]');
    if (!input || !mainImage) return;
    scope.dataset.frMissingColorReady = '1';
    const notice = document.createElement('div');
    notice.className = 'fr-missing-color-notice';
    notice.hidden = true;
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.setAttribute('aria-atomic', 'true');
    const body = document.createElement('p');
    notice.append(body);
    const swatches = scope.querySelector('.fr-pdp-swatch-block');
    if (swatches) swatches.after(notice);
    else scope.querySelector('.fr-product-form')?.before(notice);
    const defaultImage = {
      src: mainImage.getAttribute('src') || '',
      alt: mainImage.getAttribute('alt') || '',
    };
    let selectedId = '';
    let forcePhoto = false;
    let queued = false;
    const setImage = (image) => {
      if (!image?.src) return;
      const next = new URL(image.src, location.href).href;
      if (mainImage.src !== next) {
        mainImage.src = image.src;
        mainImage.loading = 'eager';
      }
      mainImage.removeAttribute('srcset');
      if (image.alt) mainImage.alt = image.alt;
      gallery.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
        let active = false;
        try {
          const a = new URL(thumb.dataset.pdpImageSrc || '', location.href);
          const b = new URL(image.src, location.href);
          active = a.pathname === b.pathname;
        } catch {}
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };
    const sync = () => {
      const selected = data.variants.find((variant) => String(variant.id) === String(input.value));
      const photo = resolvePhoto(selected, data.variants, data.roles);
      const changed = String(selected?.id || '') !== selectedId;
      const missing = photo.kind === 'missing';
      notice.hidden = !missing;
      if (missing) {
        const state = stockState(selected);
        const stock = state === 'in_stock' ? 'In stock and available to order.'
          : state === 'orderable' ? 'Available to order.'
          : state === 'sold_out' ? 'Currently sold out.' : '';
        body.textContent = 'Photos for your selection are being prepared. ' + stock + ' Other product photos show style details only.';
      }
      if (changed || forcePhoto) {
        if (missing) {
          const first = gallery.querySelector('[data-pdp-product-thumb]');
          setImage(first?.dataset.pdpImageSrc
            ? { src: first.dataset.pdpImageSrc, alt: first.dataset.pdpImageAlt || defaultImage.alt }
            : defaultImage);
        } else if (photo.image && (selectedId || forcePhoto || new URL(location.href).searchParams.has('variant'))) {
          setImage(photo.image);
        }
      }
      selectedId = String(selected?.id || '');
      forcePhoto = false;
    };
    // Core selection includes synchronous correction plus an existing rAF image pass.
    // Read the actual submitted id after those have settled. Never alter that id.
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => requestAnimationFrame(() => { queued = false; sync(); }));
    };
    document.addEventListener('click', (event) => {
      const option = event.target.closest?.('[data-product-option-button], [data-variant-direct]');
      if (option && scope.contains(option) && !option.disabled) { forcePhoto = true; schedule(); }
    }, true);
    scope.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(input, { attributes: true, attributeFilter: ['value'] });
    window.addEventListener('popstate', schedule);
    window.addEventListener('load', schedule, { once: true });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
